
import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop, Watch} from 'vue-property-decorator'
import {LayoutConfig, Parts} from './types'
import { createEventBus, removeEventBus } from '@/modules/@appbase/util'

@Component({
  name: 'parts-layout',
})
export default class PartsLayout extends Vue {
  @Prop({type: Object}) layout!: LayoutConfig
  @Prop({type: Array}) parts!: Parts

  height = 0
  width = 0
  col =0

  layoutStyle = {height: '100px', width: '100px', zoom: '50%'}

  @Watch('layout.cols')
  onLayoutColsChanged() {
    this.calc()
  }

  @Watch('layout.rows')
  onLayoutRowsChanged() {
    this.calc()
  }

  created() {
    this.calc()
    createEventBus(window, 'setZoom', this.setZoom)
  }

  beforeDestroy() {
    let callback: any = null;
    removeEventBus(window, 'setZoom', callback);
  }

  setZoom(newVal: number) {
    const parts = this.parts
    const {designWidth, rowHeight, cols} = this.layout
    this.height = rowHeight // 100 / this.layout.rows
    this.width = designWidth / cols // 100 / this.layout.cols
    this.col=cols
    const maxRowIdx = Math.max(...parts.map((x) => x.rowidx))
    // 마지막 row의 웹파트 높이가 1이 아닐 수 있기 때문에
    // maxRowIdx를 가지는 웹파트 중에 높이가 가장 큰 것을 구함
    const topcnt = Math.max(
        ...parts.filter((x) => x.rowidx == maxRowIdx).map((x) => x.rowcnt)
    )
    // console.log('3333333333', parts, maxRowIdx, topcnt)
    const height = (maxRowIdx + topcnt) * rowHeight
    this.layoutStyle = {
      height: `${height}px`,
      width:  `${designWidth}px`,
      zoom: `${newVal}%`
    }
    console.log('this.layoutStyle', this.layoutStyle)
  }

  calc() {
    const parts = this.parts
    const {designWidth, rowHeight, cols} = this.layout
    this.height = rowHeight // 100 / this.layout.rows
    this.width = designWidth / cols // 100 / this.layout.cols
    this.col=cols
    const maxRowIdx = Math.max(...parts.map((x) => x.rowidx))
    // 마지막 row의 웹파트 높이가 1이 아닐 수 있기 때문에
    // maxRowIdx를 가지는 웹파트 중에 높이가 가장 큰 것을 구함
    const topcnt = Math.max(
        ...parts.filter((x) => x.rowidx == maxRowIdx).map((x) => x.rowcnt)
    )
    // console.log('3333333333', parts, maxRowIdx, topcnt)
    const height = (maxRowIdx + topcnt) * rowHeight
    this.layoutStyle = {
      height: `${height}px`,
      width:  `${designWidth}px`,
      zoom: '100%'
    }
    console.log('this.layoutStyle', this.layoutStyle)
  }
}
